function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import { getPlatformLinkByEnvironment } from "constants/platform-links";
import { MICRO_FRONTENDS_DOMAIN, MONDAY_AUTH_DOMAIN } from "constants/links";
import { PREFETCH_TYPES } from "constants/prefetch-constants";
import { isDevelopment, env } from "services/environment-service";
import { TridentSkeleton } from "@mondaydotcomorg/trident-skeleton";
const SIGNUP_CLOUDINARY_ASSETS_DIRECTORY = "https://dapulse-res.cloudinary.com/image/upload/monday_platform/signup";
const SIGNUP_BACKGROUND_IMAGE_SRC = `${SIGNUP_CLOUDINARY_ASSETS_DIRECTORY}/signup-background.png`;
const SIGNUP_LOADER_IMAGE_SRC = `${SIGNUP_CLOUDINARY_ASSETS_DIRECTORY}/loader_transparent_new.gif`;
const SET_UP_YOUR_ACCOUNT_RIGHT_SIDE_ASSET = `${SIGNUP_CLOUDINARY_ASSETS_DIRECTORY}/signup-right-side-assets/set-up-your-account-right-side-asset.png`;
const COMPANY_AND_TEAM_SIZE_RIGHT_SIDE_ASSET = `${SIGNUP_CLOUDINARY_ASSETS_DIRECTORY}/signup-right-side-assets/company-and-team-size-right-side-asset.png`;
const HOW_WOULD_YOU_LIKE_TO_USE_MONDAY_RIGHT_SIDE_ASSET = `${SIGNUP_CLOUDINARY_ASSETS_DIRECTORY}/signup-right-side-assets/how-would-you-like-to-use-monday-right-side-asset.png`;
const WHAT_BRINGS_YOU_HERE_RIGHT_SIDE_ASSET = `${SIGNUP_CLOUDINARY_ASSETS_DIRECTORY}/signup-right-side-assets/what-brings-you-here-right-side-asset.png`;
const STATIC_ASSETS_HREFS = [
    SIGNUP_BACKGROUND_IMAGE_SRC,
    SIGNUP_LOADER_IMAGE_SRC,
    SET_UP_YOUR_ACCOUNT_RIGHT_SIDE_ASSET,
    COMPANY_AND_TEAM_SIZE_RIGHT_SIDE_ASSET,
    HOW_WOULD_YOU_LIKE_TO_USE_MONDAY_RIGHT_SIDE_ASSET,
    WHAT_BRINGS_YOU_HERE_RIGHT_SIDE_ASSET
];
const PREFETCHED_DOMAINS = [
    getPlatformLinkByEnvironment(MONDAY_AUTH_DOMAIN)
];
const PRECONNECT_DOMAINS = PREFETCHED_DOMAINS;
const PrefetchedSignupAssetsContext = /*#__PURE__*/ createContext("PrefetchedSignupAssets");
const HOST_NAME = "homepage";
const SIGNUP_MF_NAME = "mf-platform-signup";
export const PrefetchSignupAssetsProvider = (props)=>{
    const { children, signupDynamicAssetsLinks } = props;
    const [prefetchedSignupAssetsLinks, setPrefetchedSignupAssetsLinks] = useState([]);
    useEffect(()=>{
        if (isDevelopment) return;
        try {
            const skeleton = new TridentSkeleton({
                api: {},
                isDev: isDevelopment,
                mfUrl: MICRO_FRONTENDS_DOMAIN,
                host: {
                    name: HOST_NAME,
                    environment: env
                },
                isAssetsFlattened: true,
                shouldUseMfAssetsEndpoint: true,
                useMfAssetsFallback: true
            });
            skeleton.preFetchMF(SIGNUP_MF_NAME);
        } catch (e) {
        // just to keep it safe and quiet
        }
    }, []);
    useEffect(()=>{
        const setData = function() {
            var _ref = _async_to_generator(function*() {
                const signupAssetsLinks = [];
                // dns prefetches
                PREFETCHED_DOMAINS.forEach((href)=>{
                    signupAssetsLinks.push({
                        type: PREFETCH_TYPES.DNS_PREFETCH,
                        href
                    });
                });
                // pre-connects
                PRECONNECT_DOMAINS.forEach((href)=>{
                    signupAssetsLinks.push({
                        type: PREFETCH_TYPES.PRECONNECT,
                        href
                    });
                });
                // static assets
                STATIC_ASSETS_HREFS.forEach((href)=>{
                    signupAssetsLinks.push({
                        type: PREFETCH_TYPES.PREFETCH,
                        href
                    });
                });
                // dynamic assets
                signupAssetsLinks.push(...signupDynamicAssetsLinks);
                setPrefetchedSignupAssetsLinks(signupAssetsLinks);
            });
            return function setData() {
                return _ref.apply(this, arguments);
            };
        }();
        setData();
    }, []);
    return /*#__PURE__*/ _jsx(PrefetchedSignupAssetsContext.Provider, {
        value: prefetchedSignupAssetsLinks,
        children: children
    });
};
export const usePrefetchedSignupAssets = ()=>{
    const prefetchedSignupAssetsLinks = useContext(PrefetchedSignupAssetsContext) || [];
    return prefetchedSignupAssetsLinks;
};
